import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { Card } from "../Card/Card";
import { IconX } from "@tabler/icons-react";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { SecondaryButton } from "../Buttons/SecondaryButton";

interface PErrorProps {
  onClose: () => void;
  messages: string[];
}

export const PError: React.FC<PErrorProps> = ({ onClose, messages }) => {
  const t = useTranslations("errors");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <motion.div
      className="fixed left-0 top-0 bg-black/50 flex items-center justify-center sm:pr-[var(--ai-rail-push)] transition-[padding] duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none h-screen w-screen z-9999"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ type: "spring", damping: 20, stiffness: 300 }}
      >
        <Card
          padding="p-6"
          width="w-105 max-w-[90vw]"
          height="h-auto"
          justify="justify-start items-start"
          header={t("error")}
          icon={IconX}
          iconActionOnClick={onClose}
        >
          <div className="mt-4 mb-8 flex flex-col w-full space-y-2 body-2-regular text-secondary">
            {messages.map((message, index) => (
              <div key={index}>{message}</div>
            ))}
          </div>
          <SecondaryButton width="w-full" text={t("close")} onClick={onClose} />
        </Card>
      </motion.div>
    </motion.div>,
    document.body,
  );
};
